import { render, staticRenderFns } from "./sellproduct.vue?vue&type=template&id=1ac1faf4&scoped=true"
import script from "./sellproduct.vue?vue&type=script&lang=js"
export * from "./sellproduct.vue?vue&type=script&lang=js"
import style0 from "./sellproduct.vue?vue&type=style&index=0&id=1ac1faf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac1faf4",
  null
  
)

export default component.exports